import { render, staticRenderFns } from "./BulkEditFormModal.vue?vue&type=template&id=108dc6fc"
import script from "./BulkEditFormModal.vue?vue&type=script&lang=js"
export * from "./BulkEditFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports